import './suggestions.scss';
import React from 'react';
import { Link } from 'react-router-dom';
import { useConfigApp } from '../../shared/services/general/app-context';

function Suggestions ({ data }) {
	const configApp = useConfigApp();

	const getTypeProgram = (type) => {
		if (type === 'MOVIE') {
			return 'movies'
		} else if (type === 'SERIES') {
			return 'series'
		}
		return 'movies'
	}

	return (
		<div className="movie-suggestions" dir="rtl">
			<div style={{padding: "0 12px"}}>
				<h2 className="title">پیشنهادهای {configApp?.title}</h2>
				<div className="movie-grid">
					{data?.programs.map((movie) => (
						<Link to={`/${getTypeProgram(movie?.type)}/${movie.programId || movie.id}`}
							  key={movie.programId} className="movie-card">
							<div className="image-box">
								<img src={movie.image} alt={movie.title} className="movie-image" />
							</div>
							<div className="movie-title">{movie.title}</div>
						</Link>
					))}
				</div>
			</div>

		</div>
	)
}

export default Suggestions;